/* eslint-disable import/prefer-default-export, react/prop-types */

export function shouldUpdateScroll({routerProps: { location }, getSavedScrollPosition}) {
    const currentPosition = getSavedScrollPosition(location)
    // noinspection JSCheckFunctionSignatures
    window.scrollTo(...(currentPosition || [0, 0]))
    return false;
}
